/* global s */
'use strict';

class VoiceCreditSection {
	constructor(props) {
		let _that = this;
		_that.section = 'voice';
		_that.min_quantity = null;
		_that.max_quantity = null;
		_that.default_quantity = null;
		_that = Object.assign(_that, props);
		console.log('VoiceCreditSection::constructor(%o)', _that);
		if (_that.min_quantity !== null) {
			_that.min_quantity = parseFloat(_that.min_quantity);
			if (isNaN(_that.min_quantity)) {
				_that.min_quantity = null;
			}
		}
		if (_that.max_quantity !== null) {
			_that.max_quantity = parseFloat(_that.max_quantity);
			if (isNaN(_that.max_quantity)) {
				_that.max_quantity = null;
			}
		}
		if (_that.default_quantity !== null) {
			_that.default_quantity = parseFloat(_that.default_quantity);
			if (isNaN(_that.default_quantity)) {
				_that.default_quantity = null;
			}
		}
		if (_that.selected_quantity !== null) {
			_that.selected_quantity = parseFloat(_that.selected_quantity);
			if (isNaN(_that.selected_quantity)) {
				_that.selected_quantity = null;
			}
		}
		_that.buy_voice_section = document.getElementById('buy_voice_section');
		_that.predefined_amounts = _that.buy_voice_section.querySelectorAll('.predefined-rate');
		_that.custom_amount = document.getElementById('buy-custom-amount');
		_that.custom_amount_container = document.getElementById('custom-amount-container');
		const initial_quantity = _that.selected_quantity ? _that.selected_quantity : _that.default_quantity;
		let found_initial_quantity = false;

		_that.predefined_amounts.forEach(predefined_amount => {
			predefined_amount.addEventListener('click', () => {
				_that.resetPredefined();
				_that.resetCustom();
				const {amount, valid} = _that.validateAmount(predefined_amount.dataset.amount);
				predefined_amount.classList.add('active');

				_that.buy_voice_section.dispatchEvent(new CustomEvent('predefined_amount_click', {
					detail: {
						amount: amount,
						valid: valid,
						apple_code: predefined_amount.dataset.apple_code,
						apple_amount: predefined_amount.dataset.amount
					}
				}));
			});

			if (!found_initial_quantity && ['voice', 'rate_plan'].includes(_that.section) && initial_quantity === parseFloat(predefined_amount.dataset.amount)) {
				predefined_amount.dispatchEvent(new Event('click', {bubbles: true}));
				found_initial_quantity = true;
			}
		});

		if (_that.custom_amount) {
			_that.custom_amount.addEventListener('focus', () => {
				_that.resetPredefined();
				_that.custom_amount_container.classList.add('active');
			});
			_that.custom_amount.addEventListener('input', () => {
				_that.resetPredefined();
				if (s.options.page_timers) {
					clearTimeout(s.options.page_timers);
				}
				s.options.page_timers = setTimeout(() => {
					//_that.custom_amount.value = _that.custom_amount.value.toString().replace(/[^\d.,]+/g, '');
					const {amount, valid} = _that.validateAmount(_that.custom_amount.value);
					_that.custom_amount.value = amount;
					_that.buy_voice_section.dispatchEvent(new CustomEvent('custom_amount_input', {
						detail: {
							amount: amount,
							valid: valid,
						}
					}));
				}, 700);
			});
			_that.custom_amount.addEventListener('blur', () => {
				if (s.options.page_timers) {
					clearTimeout(s.options.page_timers);
				}
				const {amount, valid} = _that.validateAmount(_that.custom_amount.value);
				_that.custom_amount.value = amount;
				_that.buy_voice_section.dispatchEvent(new CustomEvent('custom_amount_blur', {
					detail: {
						amount: amount,
						valid: valid,
					}
				}));
			});

			if (!found_initial_quantity && ['voice', 'rate_plan'].includes(_that.section)) {
				_that.custom_amount.dispatchEvent(new Event('focus', {bubbles: true}));
				_that.custom_amount.value = initial_quantity;
				_that.custom_amount.dispatchEvent(new Event('input', {bubbles: true}));
			}
		}
	}

	validateAmount(amount) {
		let valid;
		amount = amount.replace(/,/gi, '.');
		amount = amount.replace(/[^\d.]/gi, '');
		amount = parseFloat(amount);
		if (isNaN(amount)) {
			amount = '';
			valid = false;
		} else {
			if (this.min_quantity !== null) {
				amount = Math.max(amount, this.min_quantity);
			}
			if (this.max_quantity !== null) {
				amount = Math.min(amount, this.max_quantity);
			}
			valid = true;
		}

		return {
			amount: amount,
			valid: valid
		};
	}

	resetPredefined() {
		this.predefined_amounts.forEach(predefined_amount => {
			predefined_amount.classList.remove('active');
		});
	}

	resetCustom() {
		if (this.custom_amount) {
			this.custom_amount.value = '';
			this.custom_amount_container.classList.remove('active');
		}
	}
}
